var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMakiArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2688 3.6689C13.5688 3.36894 13.9757 3.20044 14.4 3.20044C14.8243 3.20044 15.2311 3.36894 15.5312 3.6689L22.7312 10.8689C23.0311 11.1689 23.1996 11.5758 23.1996 12.0001C23.1996 12.4244 23.0311 12.8313 22.7312 13.1313L15.5312 20.3313C15.2294 20.6228 14.8253 20.784 14.4057 20.7804C13.9862 20.7767 13.5849 20.6085 13.2883 20.3118C12.9916 20.0152 12.8234 19.6139 12.8197 19.1943C12.8161 18.7748 12.9773 18.3707 13.2688 18.0689L17.6 13.6001H2.39999C1.97564 13.6001 1.56868 13.4315 1.26862 13.1315C0.968559 12.8314 0.799988 12.4244 0.799988 12.0001C0.799988 11.5758 0.968559 11.1688 1.26862 10.8687C1.56868 10.5687 1.97564 10.4001 2.39999 10.4001H17.6L13.2688 5.9313C12.9688 5.63125 12.8003 5.22436 12.8003 4.8001C12.8003 4.37584 12.9688 3.96894 13.2688 3.6689Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMakiArrow);
export default __webpack_public_path__ + "static/media/maki-arrow.5cf2538574d0c12c4e7916911960a11e.svg";
export { ForwardRef as ReactComponent };